<template>
    <div v-if="$can('manage', 'gateway')">
        <kt-row>
            <div id="all_corporates" class="col-sm-12 col-lg-4 col-md-4" v-for="corporate in corporates"
            v-bind:key="corporate.id">
                <kt-panel class="shadow">
                    <kt-panel-body>
                        <kt-panel-header-label class="text-center" style=";z-index: 1;">
                            <kt-panel-header-title style="" class="mt-3 text-dark">
                                <div class="mb-2" style="font-size: 1.5rem">
                                    {{ corporate.business_name }}
                                </div>
                            </kt-panel-header-title>
                            <kt-row>
                                <novin-logo v-if="corporate.psp == pspList.NOVIN"/>
                                <parsian-logo v-if="corporate.psp == pspList.PARSIAN"/>
                                <pasargad-logo v-if="corporate.psp == pspList.PASARGAD"/>
                                <saman-logo v-if="corporate.psp == pspList.SAMAN"/>
                                <sepehr-logo v-if="corporate.psp == pspList.SEPEHR"/>
                                <mellat-logo v-if="corporate.psp == pspList.MELLAT"/>
                                <ap-logo v-if="corporate.psp == pspList.ASAN_PARDAKHT "/>
                                <iran-kish-logo v-if="corporate.psp == pspList.IRANKISH "/>
                            </kt-row>
                            <!--                            <span :class="'kt-badge&#45;&#45;'+variant(corporate.status)"-->
                            <!--                                  class="kt-badge kt-badge&#45;&#45;dot mr-1"></span>-->
                            <!--                            <span :class="'text-'+variant(corporate.status)">-->
                            <!--                            {{ statusStr(corporate.status) }}-->

                            <!--                        </span>-->
                        </kt-panel-header-label>
                    </kt-panel-body>
                    <kt-row>
                        <kt-col>
                            <kt-panel-footer class="p-2 text-center">
                                <router-link
                                        class="btn btn-secondary border-0 w-100 bg-secondary text-dark btn-square"
                                        :to="'bill/corporate/' + corporate.id + '/details'"
                                >
                                    {{ $t('btn.edit') }}
                                </router-link>
                            </kt-panel-footer>
                        </kt-col>
                        <kt-col>
                            <kt-panel-footer class="p-2 text-center">
                                <kt-button
                                        class="btn btn-secondary border-0 w-100 bg-secondary text-dark btn-square"
                                        @click="deleteCorporate(corporate.id)"
                                        :id="'delete_btn_' + corporate.id"
                                >
                                    {{ $t('btn.delete') }}
                                </kt-button>
                            </kt-panel-footer>
                        </kt-col>
                    </kt-row>

                </kt-panel>
            </div>
        </kt-row>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import {
    apLogo, iranKishLogo,
    mellatLogo,
    novinLogo,
    parsianLogo,
    pasargadLogo,
    samanLogo,
    sepehrLogo
} from "../../collective/components/psp_logos";
import {billService} from '@/common/api.service'
import {KTApp} from '@/plugins/core/app';
import $ from "jquery";
import {i18n} from "@/plugins/i18n";
import toastr from 'toastr'
import {pspList} from '@/constants/psp'


export default {
    components: {
        novinLogo,
        parsianLogo,
        pasargadLogo,
        samanLogo,
        sepehrLogo,
        mellatLogo,
        apLogo,
        iranKishLogo,
    },
    data() {
        return {
            pspList,
            headerAction: {
                left: '10px',
                top: '10px',
                position: 'absolute'
            },
        }
    },
    computed: {
        ...mapGetters('bill', [
            'corporates',
        ]),
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        }
    },
    methods: {
        deleteCorporate(hashid) {
            if (confirm(i18n.t('confirm.delete_corporate'))) {
                let btn = $('#delete_btn_' + hashid)
                let form = $('#all_corporates')
                KTApp.progress(btn)
                billService.deleteCorporate(hashid).then(response => {
                    this.$store.dispatch('bill/getCorporates')
                    return this.toastr.success(i18n.t('message.corporated_removed_success'))
                }).catch(({response}) => {
                    let message = i18n.t('message.corporate_not_found')
                    KTApp.unprogress(btn)
                    return this.showMsg(form, 'danger', message)
                }).finally(() => {
                    KTApp.unprogress(btn)
                })
            }
        }
    },
    mounted() {
        this.$store.dispatch('bill/getCorporates')
    }
}
</script>

<style>

</style>